module.exports = __webpack_public_path__ + "static/media/aaron_sletten_memoji.c3c489bb.png";